<template>
  <div class="container bigger-top-margin">
    <div class="row justify-content-center">
      <div class="col">
        <div class="card card-default">
          <div class="card-header">Contact</div>

          <div class="card-body">
            Do you have a question about the app?<br>
            Want to report an issue or suggest a feature enhancement?<br>
            Or do you simply wanna say "hi" and let me know how happy you are with the app?<br>
            <br>
            I'm one e-mail away — <mark><a href="mailto:support@expense.guide">support@expense.guide</a></mark>
            <br>
            <br>
          </div>
          <div class="floating-bottom-container"><button onclick="window.history.back()" class="btn btn-primary floating-bottom-right">Go Back</button></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Contact',
  data () {
    return {}
  }
}
</script>
